import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { customFieldsService } from '../api/custom-fields.service';
import { CUSTOM_FIELD_KEYS } from './queryKeys';

/**
 * Uploads a file for a `Files`/`Signature` field value — the only way to write those
 * two types (`PUT .../field-values/{fieldId}` rejects them outright).
 *
 * @remarks
 * Uploading to a field that already has a file replaces it — the old file is deleted
 * from storage automatically on the backend.
 */
export function useUploadTaskFieldValueFile(taskId: string) {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: ({ fieldId, file }: { fieldId: string; file: File }) =>
      customFieldsService.uploadTaskFieldValueFile(taskId, fieldId, file),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CUSTOM_FIELD_KEYS.taskValues(activeOrganizationId ?? '', taskId),
      });
    },
  });
}
